<template>
  <div class="document__form">
    <h3>File</h3>
    <FilesList :files="files" :isEditable="true" @deleted="deleteByIdHandler" />
    <FileUploadForm
      type="default"
      @successUpload="successUploadHandle"
      @delete="deleteByIdHandler"
    />
    <vs-textarea
      label="Description"
      v-model="desc"
      counter="500"
      :maxlength="500"
    ></vs-textarea>

    <div class="save-popup-button">
      <vs-button icon="save" @click="saveDocument" :disabled="uploading">
        {{ uploading ? 'Saving...' : 'Save' }}
      </vs-button>
    </div>
  </div>
</template>

<script>
import FileUploadForm from '@/components/files/fileUploadForm'
import FilesList from '@/components/files/filesList'

export default {
  name: 'DocumentForm',
  data() {
    return {
      desc: '',
      file_ids: [],
      files: [],
      uploadedFiles: [],
      uploading: false,
    }
  },
  components: { FileUploadForm, FilesList },
  methods: {
    successUploadHandle: function(file) {
      this.files = [...this.files, file]
      this.file_ids = [...this.file_ids, file.id]
      this.uploadedFiles = [...this.uploadedFiles, file]
    },
    deleteByIdHandler: function(file_id) {
      const file = this.files.find(f => f.id == file_id)
      if (file && file.id) {
        const file_id_idx = this.file_ids.findIndex(id => id == file_id)
        const exist_file_id_idx = this.files.findIndex(f => f.id == file_id)
        if (file_id_idx != -1) {
          this.file_ids.splice(file_id_idx, 1)
        }
        if (exist_file_id_idx != -1) {
          this.files.splice(exist_file_id_idx, 1)
        }
      }
      const uploadedFile = this.uploadedFiles.find(f => f.id == file_id)
      if (uploadedFile && uploadedFile.id) {
        const file_id_idx = this.file_ids.findIndex(id => id == file_id)
        if (file_id_idx != -1) {
          this.file_ids.splice(file_id_idx, 1)
        }
      }
    },
    saveDocument: function() {
      if (!this.file_ids.length) {
        this.$vs.notify({
          title: 'Error',
          text: 'Upload a file first',
          color: 'danger',
          position: 'top-right',
        })
        return
      }
      this.uploading = true
      this.$store
        .dispatch('documents/createDocumentAction', {
          data: {
            desc: this.desc,
            files: this.file_ids,
          },
        })
        .then(() => {
          this.$emit('closePopup')
        })
        .catch(r => {
          this.$vs.notify({
            title: 'Error',
            text: r.message,
            color: 'danger',
            position: 'top-right',
          })
        })
        .finally(() => {
          this.uploading = false
        })
    },
  },
}
</script>

<style lang="scss">
.document__form {
  padding: 0 5px;
  .vs-input {
    width: 100%;
  }
  & > .vs-row {
    flex-flow: row nowrap;
    & > .vs-col {
      flex: 1;
      padding: 1rem;
      margin: 0 1rem;
      box-shadow: 0 0 10px 1px #ddd;
      border-radius: 0.5rem;
    }
  }
  h3 {
    margin: 1rem 0 0.5rem 0;
  }
  .con-img-upload {
    margin-top: 0;
  }
}
</style>
